import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

// Cinta hi-vis de peligro; el negro del gradiente es fijo (no varía por tema)
const Tape = ({ height = 6, sx }) => {
  const theme = useTheme()
  return (
    <Box
      aria-hidden="true"
      sx={{
        height,
        width: '100%',
        flex: '0 0 auto',
        background: `repeating-linear-gradient(135deg, ${theme.palette.custom.hiVis} 0 13px, #14161c 13px 21px)`,
        ...sx,
      }}
    />
  )
}

export default Tape
